<template lang="html">

    <section class="wrapper legal">
    
        <div class="container -rgpd" :show="showtext" v-if="!showpopup">

            <template v-if="!!texto">

                <a @click="back" class="link">Volver</a>

                <div v-html="texto"></div>

                <div class="contenedor-botones row-center">
                    
                    <a class="btn skull" @click="back">Volver</a>
                </div>
            </template>
            <template v-else>
                <div class="loading"></div>
            </template>

        </div>

        <popup-rgpd @hide="sethidepopup" :show="showpopup"></popup-rgpd>

    </section>

</template>

<script lang="js">

    import { mapActions } from 'vuex';
    import router from '@/router';
    import popuprgpd from '@/components/parts/popup-rgpd';

    export default {
        name: 'RGPD',
        data() {
            return {
                texto: '',
                loading: false,
                showtext : false,
                showpopup: true
            }
        },
        mounted() {
            this.requestRGPD().then(r => {
                this.texto = r;
            });
        },
        methods: {
            ...mapActions(['requestRGPD', 'requestLogout', 'acceptRGPD','setError']),
            logout() {
                this.requestLogout().then(() => {
                    router.push({ name: 'login' })
                })
            },
            aceptar() {
                this.loading = true;
                this.acceptRGPD().then(r => {
                    if (r) {
                        router.push({ name: 'home' })
                        this.loading = false;
                    }
                })
            },
            back(){
                this.showpopup = true;
                this.showtext = false;
            },
            sethidepopup(){
                this.showtext = true;
                this.showpopup = false;
            }
        },
        components: {
            'popup-rgpd': popuprgpd
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/views/rgpd.vue